<template>

    <div class="add_contacts_file_upload_container">

        <h3 class="title is-size-5">Ajouter des fichiers</h3>
        <FilesUploader @fileUploaded="handleUploadedFile" />

        <button @click="sendFiles" class="button is-info is-outlined">
            {{ $t('components.shared.filesUpload.contactValidateFileUpload') }}
        </button>
    </div>


</template>


<script>
import FilesUploader from '@/components/shared/filesUploader/filesUploader'

export default {
    name: 'AddContactsUploadFiles',
    components: {
        FilesUploader
    },
    data(){
        return {
            fileList: []
        }
    },
    computed: {
    },
    methods: {
        handleUploadedFile(fileList){
            this.fileList = fileList
        },
        sendFiles(){
            this.$emit('fileUploaded', this.fileList)
        }
    }
}
</script>

<style lang="scss" >
    .add_contacts_file_upload_container{
        .button{
            margin-top: 12px;
            width: 100%;
        }
    }
</style>